import { LimitCheckResult, LimitMeasurement } from "@/client-admin/types.gen";
import { cn } from "@/lib/utils";
import { BREACH_UNITS, formatCheckValue, formatPeriod } from "./tradingLimits";

export const measurementPeriod = (measurement: LimitMeasurement): string =>
  measurement.start && measurement.end ? formatPeriod(measurement.start, measurement.end) : "Day";

const formatPrice = (price?: string | null): string => (price == null ? "—" : Number(price).toFixed(2));

/** Every breach of one check, one line each; price checks also show the two prices compared. */
export function BreachList({ result }: { result: LimitCheckResult }) {
  const priceCheck = result.limit_name === "PriceDelta";
  const columns = priceCheck ? "grid-cols-[6rem_1fr_1fr_1fr_1fr]" : "grid-cols-[6rem_1fr_1fr]";
  return (
    <div className="max-h-56 overflow-y-auto text-xs tabular-nums">
      <div className={cn("sticky top-0 grid gap-x-3 bg-red-50 py-1 text-right text-muted-foreground", columns)}>
        <span className="text-left">{BREACH_UNITS[result.limit_name].column}</span>
        {priceCheck && <span>Limit price</span>}
        {priceCheck && <span>Day Ahead</span>}
        <span>{priceCheck ? "Away" : "Actual"}</span>
        <span>{priceCheck ? "Allowed" : "Limit"}</span>
      </div>
      {result.breaches.map((breach) => (
        <div key={`${breach.start}-${breach.end}`} className={cn("grid gap-x-3 py-0.5 text-right", columns)}>
          <span className="text-left">{measurementPeriod(breach)}</span>
          {priceCheck && <span>{formatPrice(breach.limit_price)}</span>}
          {priceCheck && <span>{formatPrice(breach.day_ahead_price)}</span>}
          <span className="font-medium text-red-700">{formatCheckValue(breach.limit_name, breach.actual)}</span>
          <span>{formatCheckValue(breach.limit_name, breach.limit)}</span>
        </div>
      ))}
    </div>
  );
}
